module.exports = __webpack_public_path__ + "img/66.40d58a15.jpg";